import { Link } from "react-router-dom";
import { toDriveDirectUrl } from "@/lib/utils";

export interface Noticia {
  id: number;
  titulo: string;
  extracto?: string;
  imagen?: string;
  fecha?: string;
  comuna?: string;
  categoria?: string;
  segmento?: string;
  subtitulo?: string;
}

interface NoticiaDestacadaCardProps {
  noticia: Noticia;
}

export default function NoticiaDestacadaCard({ noticia }: NoticiaDestacadaCardProps) {
  return (
    <div className="bg-white border border-masmed-gray-200 rounded-lg shadow-sm overflow-hidden flex flex-col h-full">
      {/* Título arriba, fuera de la imagen */}
      <div className="p-4 md:p-5 pb-3">
        <div className="flex items-start gap-3">
          <div className="w-1 h-9 md:h-10 bg-primary rounded-full flex-shrink-0 mt-0.5" />
          <h3 className="text-base md:text-[17px] text-masmed-gray-900 leading-snug"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}>
            {noticia.titulo}
          </h3>
        </div>
      </div>

      {/* Imagen grande con overlay y datos */}
      <div className="relative flex-1 min-h-[180px] md:min-h-[220px] lg:min-h-[240px]">
        <img
          src={toDriveDirectUrl(noticia.imagen || "")}
          alt={noticia.titulo}
          className="w-full h-full object-cover object-top"
        />

        {/* Badge NOTICIA DESTACADA */}
        <div className="absolute top-3 left-3 bg-primary text-white text-[10px] md:text-xs uppercase tracking-wider px-2 py-1 rounded"
        style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}>
          NOTICIA DESTACADA
        </div>

        {/* Overlay inferior oscuro degradado con texto, comuna y fecha */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent p-4 md:p-5 pt-14 md:pt-16">
          <p className="text-white text-sm md:text-[15px] leading-relaxed mb-2 line-clamp-2">
            {noticia.extracto}
          </p>
          <div className="flex items-center justify-between">
            <span className="text-white text-xs md:text-sm"
            style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 600 }}>{noticia.comuna}</span>
            <span className="text-white/90 text-xs md:text-sm">{noticia.fecha}</span>
          </div>
        </div>
      </div>

      {/* Botón Ver más centrado abajo */}
      <div className="px-4 md:px-5 py-3 md:py-4 flex justify-center">
        <Link
          to={`/noticias/${noticia.id}`}
          className="inline-flex items-center justify-center px-5 py-1.5 bg-primary text-white text-xs md:text-sm rounded hover:bg-primary-dark transition-colors duration-200 cursor-pointer"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}
        >
          Ver más
        </Link>
      </div>
    </div>
  );
}